import { render } from "./ByLiftRoadmap.vue?vue&type=template&id=3929e585&scoped=true"
import script from "./ByLiftRoadmap.vue?vue&type=script&lang=js"
export * from "./ByLiftRoadmap.vue?vue&type=script&lang=js"

import "./ByLiftRoadmap.vue?vue&type=style&index=0&id=3929e585&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3929e585"]])

export default __exports__